import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class WmsInventarioContagemService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async search({
    inventario_id,
    deposito,
    rua,
    predio,
    nivel,
    tipoender,
    sku,
  }) {
    const url = unifyParams(`/wms-inventario-contagem/search/${this.idconta}`, [
      {
        key: 'inventario_id',
        value: inventario_id,
      },
      {
        key: 'deposito',
        value: deposito,
      },
      {
        key: 'rua',
        value: rua,
      },
      {
        key: 'predio',
        value: predio,
      },
      {
        key: 'nivel',
        value: nivel,
      },
      {
        key: 'tipoender',
        value: tipoender,
      },
      {
        key: 'sku',
        value: sku,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async getByOs(osId) {
    const response = await apinode.get(
      `/wms-inventario-contagem/os/${osId}/${this.idconta}`,
    )

    return response.data
  }

  async getChildren({
    inventario_id,
    codendereco,
    os_id,
    numero_contagem,
    sku,
  }) {
    const url = unifyParams(`/wms-inventario-contagem/filhos/${this.idconta}`, [
      {
        key: 'inventario_id',
        value: inventario_id,
      },
      {
        key: 'codendereco',
        value: codendereco,
      },
      {
        key: 'os_id',
        value: os_id,
      },
      {
        key: 'numero_contagem',
        value: numero_contagem,
      },
      {
        key: 'sku',
        value: sku,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }
}

export default new WmsInventarioContagemService()
